export const NotificationIcon = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='16' height='16' rx='8' fill='#94A3B8' />
    <path
      d='M8.70898 5.66016V12H7.29102V5.66016H8.70898ZM7.19727 3.99609C7.19727 3.78125 7.26758 3.60352 7.4082 3.46289C7.55273 3.31836 7.75195 3.24609 8.00586 3.24609C8.25586 3.24609 8.45312 3.31836 8.59766 3.46289C8.74219 3.60352 8.81445 3.78125 8.81445 3.99609C8.81445 4.20703 8.74219 4.38281 8.59766 4.52344C8.45312 4.66406 8.25586 4.73438 8.00586 4.73438C7.75195 4.73438 7.55273 4.66406 7.4082 4.52344C7.26758 4.38281 7.19727 4.20703 7.19727 3.99609Z'
      fill='white'
    />
  </svg>
);
